import BusinessCreateForm from './BusinessCreateForm';

export default BusinessCreateForm;
